import { Menu, X } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from 'motion/react';

interface MenuItem {
  id: string;
  label: string;
  icon: React.ElementType;
}

interface SidebarProps {
  menuItems: MenuItem[];
  activePage: string;
  setActivePage: (id: string) => void;
  isCollapsed: boolean,
  setIsCollapsed: (value:any) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  menuItems,
  activePage,
  setActivePage,
  isCollapsed,
  setIsCollapsed
}) => {

  return (
    <>
      {/* Mobile Overlay */}
      {!isCollapsed && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsCollapsed(true)}
        />
      )}
      {/* Sidebar */}
      <aside
        className={`fixed lg:sticky top-0 left-0 h-screen bg-[#1e293b] text-[#e2e8f0] transition-all duration-300 z-50 flex flex-col ${
          isCollapsed ? '-translate-x-full lg:translate-x-0 lg:w-20' : 'w-72'
        }`}
      >
        {/* Logo & Toggle */}
        <div className="h-16 flex items-center justify-between px-5 border-b border-[#334155]/50">
          {!isCollapsed && (
            <div className="flex items-center gap-3 mt-5 mb-3 justify-center w-full">
                <img src="/images/MetaFox-White.png" alt="logo" className="w-40 h-auto mx-auto" />
            </div>
          )}
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-2 hover:bg-[#334155] rounded-xl transition-all active:scale-95"
          >
            {isCollapsed ? <Menu size={20} /> : <X size={20} />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3">
          {menuItems.map((item: any) => {
            const Icon = item.icon;
            const isActive = activePage === item.id;

            return (
              <Link
                to={`/metafox-admin${item.path}`}
                key={item.id}
                onClick={() => {
                  setActivePage(item.id);
                  if (window.innerWidth < 1024) {
                    setIsCollapsed(true);
                  }
                }}
                className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl mb-1 transition-all relative group ${isActive
                    ? 'bg-[#2563eb] text-white shadow-lg shadow-blue-500/20'
                    : 'text-[#cbd5e1] hover:bg-[#334155] hover:text-white'
                  } ${isCollapsed ? 'justify-center' : ''}`}
              >
                <Icon size={20} className="flex-shrink-0 relative z-10" />
                {!isCollapsed && (
                  <span className="font-medium text-sm relative z-10">{item.label}</span>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        {!isCollapsed && (
          <div className="p-5 border-t border-[#334155]/50">
            <p className="text-xs text-[#94a3b8] font-medium">© 2026 MetaFoxTech</p>
            <p className="text-xs text-[#64748b] mt-1">Dashboard v1.0</p>
          </div>
        )}
      </aside>
    </>
  );
};

export default Sidebar;
